import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { RRIInputOption } from '../../interfaces/input-option.interface';
import { RRIInput } from '../../interfaces/input-settings.interface';

@Component({
  selector: 'rr-radio-button-field',
  templateUrl: './radio-button-field.component.html',
  styleUrls: ['./radio-button-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RadioButtonFieldComponent),
      multi: true,
    },
  ],
})
export class RadioButtonFieldComponent<T>
  implements OnInit, ControlValueAccessor, Validator
{
  public data: RRIInputOption<T> = null;

  public control: NgControl;
  public onChangeFn: any = () => {};
  public onTouchFn: any = () => {};
  private errorMessages = new Map<string, () => string>();

  @Input() settings: RRIInput<RRIInputOption<T>>;
  @Input() options: RRIInputOption<T>[];
  @Input() customErrorMessages: Map<string, () => string>;
  @Input() disabled = false;
  @Input() required: boolean = false;

  constructor(private inj: Injector) {
    this.errorMessages.set(
      'required',
      () => `${this.settings.label} is required.`,
    );
  }

  ngOnInit(): void {
    this.control = this.inj.get(NgControl, null);

    if (this.customErrorMessages && this.customErrorMessages.size) {
      this.errorMessages = new Map([
        ...Array.from(this.errorMessages.entries()),
        ...Array.from(this.customErrorMessages.entries()),
      ]);
    }
  }

  public onValueChange(option: RRIInputOption<T>): void {
    this.data = option;
    this.onChange();
  }
  writeValue(selectedOption: RRIInputOption<T>): void {
    this.data = selectedOption;
  }

  registerOnChange(fn: (rating: number) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  public onChange() {
    this.onChangeFn(this.data);
  }
  public onTouched() {
    this.onTouchFn();
  }
  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched, value } = this.control;

    return this.invalid ? dirty || touched || !!value : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map((key) => {
      return this.errorMessages.has(key)
        ? this.errorMessages.get(key)()
        : 'error: ' + key;
    });
  }
  public validate(_control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
